/**
 * Performs a case-insenstive check if string contains substring
 * @param {string} substring - string that might be contained
 * @param {string} string - string that might contain substring
 * @return {boolean}
 */
export default function containsSubstring(substring, string) {
  return string.toLowerCase().includes(substring.toLowerCase());
}
